// The same small parser is used by both upload utilities and the backend.
// Location identifies scope, not authorization; Security Rules enforce access.
function storageLocation(fullPath, parent, uid) {
  const parts = String(fullPath || "").split("/");
  const p = String(parent || "").split("/");
  let spaceId = null,
    stationId = null,
    group = "personal",
    category;
  if (parts[0] === "space") {
    spaceId = p[0] === "space" && p[1] ? p[1] : parts[1];
    if (parts[2] === "stations" && parts[3]) {
      stationId = parts[3];
      category = { taskImages: "task", notesImages: "note", files: "file" }[parts[4]];
      group = category === "file" ? "project" : "photos";
    } else {
      category = parts[2] === "logos" ? "logo" : "brief";
      group = "workspace";
    }
  } else if (parts[0] === "users" && parts[1] === uid) {
    category = {
      profile: "profile",
      taskImages: "task",
      notesImages: "note",
      journal: "journal",
      shared: "chat",
    }[parts[2]];
    if (category === "chat" && p[0] === "space" && p[1]) {
      spaceId = p[1];
      stationId = p[2] === "stations" ? p[3] : null;
      group = "chat";
    }
  } else if (parts[0] === "posts" && parts[1] === uid) {
    category = "post";
  }
  return category && uid && (!spaceId || !spaceId.includes("/"))
    ? { spaceId, stationId, group, category }
    : null;
}
module.exports = { storageLocation };
